import { Cache } from "aws-amplify";
import ContactUs from "../components/organisms/Contact-Us";
import Header from "../components/organisms/Header";

const PageError = (props) => {
  // Get the 'product' param from location state if available, otherwise from query string
  const product = Cache.getItem("product_type")??"";
  return (
    <div>
      <Header headerTitle={props.headerTitle} />

      <main>
        <div className="page-not-found">
          <img
            src={"/images/sici-logo.png"}
            width="180"
            height="50"
            alt="logo"
            className="mx-auto mb-5"
          />
          <p className="mx-auto font-bold text-black-600 text-xs mt-5 mb-5 text-left" >
            We’re sorry that we were not able to process your request 
for a {product??""} policy. We ran into an issue while validating
your GCash information. 
          </p>
          <p className="mx-auto font-bold text-black-600 text-xs text-left">Should you need any assistance, you may email us at 
ginsure@standard-insurance.com or you
may contact us at (02) 8 8451111.</p>
        </div>
      </main>
    </div>
  );
};
export default PageError;
